import { Code } from 'models/common/CommonCode';

export enum CommonYN {
  Y = 'Y',
  N = 'N',
}

export enum PageMode {
  READ = 'READ',
  WRITE = 'WRITE',
  EDIT = 'EDIT',
  COPY = 'COPY',
  DELETE = 'DELETE',
}

export enum ManagementMode {
  CREATE = 'C',
  CREATE_EXCEL = 'CE',
  MODIFY = 'M',
  MODIFY_EXCEL = 'ME',
  DELETE = 'D',
  READ = 'R',
}

/**
 * 업무구분
 *
 * 파일저장경로 중 업무 폴더명으로 사용 (없는 경우 etc)
 */
export enum BizName {
  ETC = 'etc',
  GTNG = 'gtng',
  IP = 'ip',
  MP = 'mp',
  MD = 'md',
  SNSR = 'snsr',
  TPL = 'tpl',
  SETUP = 'setup',
}

/**
 * 파일유형
 */
export enum FileTypeName {
  NORMAL = 'NORMAL',
  GTNG_MASTER = 'GTNG_MASTER',
  GTNG_EVIDENCE = 'GTNG_EVIDENCE',
  GTNG_S_RST = 'GTNG_S_RST',
  GTNG_F_RST = 'GTNG_F_RST',
  TPL_IP_LIST = 'TPL_IP_LIST',
  TPL_IP_RST = 'TPL_IP_RST',
  TPL_SNSR_LIST = 'TPL_SNSR_LIST',
  TPL_MP_LIST = 'TPL_MP_LIST',
  TPL_EQP_LIST = 'TPL_EQP_LIST',
  TPL_UT_REGIST = 'TPL_UT_REGIST',
  TPL_SETUP_EQP_LIST = 'TPL_SETUP_EQP_LIST',
  TPL_SETUP_EQP_EMPTY_LIST = 'TPL_SETUP_EQP_EMPTY_LIST',
  TPL_SETUP_SCHD_LIST = 'TPL_SETUP_SCHD_LIST',
  TPL_SETUP_DRPT_LIST = 'TPL_SETUP_DRPT_LIST',
  GUIDE_UT_REGIST = 'GUIDE_UT_REGIST',
  TPL_SETUP_ITEM_LIST = 'TPL_SETUP_ITEM_LIST',
  TPL_SETUP_ITEM_MNL = 'TPL_SETUP_ITEM_MNL',
  TPL_SETUP_MAP_CHART = 'TPL_SETUP_MAP_CHART',
  TPL_SETUP_PKG_LIST = 'TPL_SETUP_PKG_LIST',
  TPL_IDL_ASST_UPLOAD = 'TPL_IDL_ASST_UPLOAD',
  TPL_IDL_ETC_UPLOAD = 'TPL_IDL_ETC_UPLOAD',
  DAILY_REPORT = 'DAILY_REPORT',
  TPL_MD_IVES_DB = 'TPL_MD_IVES_DB',
  TPL_MD_EQP_SPEC = 'TPL_MD_EQP_SPEC',
  TPL_MD_IVES_RESULT = 'TPL_MD_IVES_RESULT',
}

export const commonYNcodes: Code[] = [
  { cmnCd: 'Y', cmnCdNm: 'Y' },
  { cmnCd: 'N', cmnCdNm: 'N' },
];

export const commonYNarr: Option[] = [
  { optionName: 'Y', optionValue: 'Y' },
  { optionName: 'N', optionValue: 'N' },
];

export interface Option {
  optionName: string;
  optionValue: string;
}

export enum FileUpload {
  maxSize = 1073741824, // 1GB
}
